import escapeHtml from 'escape-html'
import { Text } from 'slate'

// const config = require('../../config').config;

const makeListItem = (isOL, listDepth, children) => {
    if (!children.endsWith('\n')) {
        children = children + '\n';
    }

    let spacer = '';
    for (let k = 1; listDepth > k; k++) {
        if (isOL) {
            // https://github.com/remarkjs/remark-react/issues/65
            spacer += '   ';
        } else {
            spacer += '  ';
        }
    }
    return `${spacer}${isOL ? '1.' : '-'} ${children}`;
}

const followedBySameTypeBlock = (block, type, index, blocks) => {
    if (index === blocks.length - 1) {
        return false;
    }

    return block[type] === blocks[index + 1][type]
}

export const serialize = (server_host, node, parentNode, listDepth = 0, listType) => {
    if (Text.isText(node)) {
        let string = escapeHtml(node.text)
        if (node.bold) {
            string = `**${string}**`
        }

        if (node.italic) {
            string = `*${string}*`
        }

        if (node.underline) {
            string = `<u>${string}</u>`
        }

        if (node.strikethrough) {
            string = `~~${string}~~`
        }

        if (node.superscript) {
            string = `<sup>${string}</sup>`
        }

        if (node.subscript) {
            string = `<sub>${string}</sub>`
        }

        if (node.code) {
            string = `\`${string}\``
        }

        // if (node.highlight) {
        //     node.backgroundColor = '#FEF3B7';
        // }

        // if (node.color && node.backgroundColor) {
        //     string = `<span style="color: ${node.color}; background-color: ${node.backgroundColor}">${string}</span>`
        // } else if (node.color) {
        //     string = `<span style="color: ${node.color}">${string}</span>`
        // } else if (node.backgroundColor) {
        //     string = `<span style="background-color: ${node.backgroundColor}">${string}</span>`
        // }

        if (parentNode?.type === 'li') {
            return string + '\n';
        }

        return string
    }


    if (['ol', 'ul'].includes(node.type)) {
        listDepth = listDepth + 1;
        listType = node.type;
    }

    const children = node.children.map(n => serialize(server_host, n, node, listDepth, listType)).join('')

    switch (node.type) {
        case 'blockquote':
            return `> ${children}`
        case 'ul':
        case 'ol':
            return `${children}`;
        case 'lic':
        case 'li':
            if (node.type === 'li' && node.children[0].type && node.children[0].type != 'p') {
                return children;
            }

            return makeListItem(listType == 'ol', listDepth, children);

        case 'action_item':
            if (node.checked) {
                return `- [x] ${children}`
            } else {
                return `- [ ] ${children}`
            }
        case 'p':
            if (['disc', 'decimal'].includes(node.listStyleType)) {
                return makeListItem(node.listStyleType == 'decimal', node.indent, children)
            }

            return `${children || ''}`
        case 'media_embed':
            return `![${children}](${escapeHtml(node.url) || ''})`
        case 'a':
            return `[${children}](${escapeHtml(node.url) || ''})`
        case 'img':
            return `![${escapeHtml(node.caption && node.caption[0] && node.caption[0].text || '')}](${node.url || ''})`
        case 'code_block':
            return `\`\`\`${node.lang || 'plaintext'}\n${children}\n\`\`\``
        case 'code_line':
            return `${children}\n`
        case 'h1':
            return `# ${children}`
        case 'h2':
            return `## ${children}`
        case 'h3':
            return `### ${children}`
        case 'h4':
            return `#### ${children}`
        case 'h5':
            return `##### ${children}`
        case 'h6':
            return `###### ${children}`
        case 'hr':
            return `---`
        case 'mention':
            return `${node.value.includes('@') ? '' : '@'}${node.value}`
        case 'tag':
            return `#${node.value}`

        case 'subpage':
            let url = server_host + '#/';
            if (node.docType === 'doc') {
                url += 'editor';
            } else if (node.docType === 'flow') {
                url += 'flow';
            } else if (node.docType === 'db') {
                url += 'db';
            } else {
                url += 'slidesViewer';
            }
            url += `?hid=${node.hid}`;

            return `[${node.title}](${url})`

        case 'slides-embed':
        case 'db-embed':
            const embed_url = node.type === 'db-embed' ?
                `${server_host}#/embed/db?hid=${node.hid}` :
                `${server_host}present.html?hid=${node.hid}`
            return `[${node.title || node.type}](${embed_url})`

        case 'rilmark':
            return `> ${node.highlight} ${node.note ? ('\n\nNotes: ' + node.note[0]?.text || '') : ''}`;

        // case 'math_inline':
        //     return `$${node.expression}$`
        // case 'math_block':
        //     return `$$${node.expression}$$`
        // case 'table':
        //     return `<table>${children}</table>`
        case 'tr':
            let rowContent = `${children}|\n`;
            if (node.children[0]?.type === 'th') {
                rowContent += node.children.map(c => '|---').join('') + '|\n';
            }

            return rowContent
        case 'table':
            if (!children.includes('|---')) {
                const colCount = node.children[0].children.length;
                let header = '|';
                let seperator = '|';
                for (var i = 0; i < colCount; i++) {
                    header += '|';
                    seperator += '---|';
                }
                return header + '\n' + seperator + '\n' + children;
            }

            return children;
        case 'td':
            return `|${children}`
        case 'th':
            return `|${children}`

        default:
            return children;
    }
}

export const slateToMD = (blocks) => {
    const host = window.location.protocol + "//" + window.location.host;

    const md = blocks.map((b, index) => {
        if (['disc', 'decimal'].includes(b.listStyleType) && followedBySameTypeBlock(b, 'listStyleType', index, blocks)
            || ['action_item'].includes(b.type) && followedBySameTypeBlock(b, 'type', index, blocks)) {
            return serialize(host, b, null, 0).replace(/(\r\n|\n|\r)*$/, "");
        }

        return serialize(host, b, null, 0).replace(/(\r\n|\n|\r)*$/, "") + '\n';
    }).join('\n');

    return md?.trim();
}

export const parseMarkdownTable = (str) => {
    // 改进的表格匹配正则，能更好地处理包含格式化文本的表格
    const tableRegex = /^(\|[^\r\n]*\|\r?\n)((?:\|[\s:]*-+[\s:]*)+\|)(\r?\n(?:\|[^\r\n]*\|\r?\n?)*)?$/gm;
    
    let match = tableRegex.exec(str);
    if (!match) {
        return null;
    }

    const headerRow = match[1];
    const separatorRow = match[2];
    const bodyRows = match[3] !== undefined ? match[3] : "";

    // 改进的单元格分割函数，能正确处理包含格式化文本的内容
    const splitTableRow = (row) => {
        const cells = [];
        let currentCell = '';
        let inCodeSpan = false;
        let i = 0;
        
        // 移除行首尾的换行符和空白
        row = row.trim();
        
        // 如果行以 | 开头或结尾，移除它们
        if (row.startsWith('|')) row = row.substring(1);
        if (row.endsWith('|')) row = row.substring(0, row.length - 1);
        
        while (i < row.length) {
            const char = row[i];
            
            if (char === '`') {
                // 处理代码段，在代码段内的 | 不应该被视为分隔符
                inCodeSpan = !inCodeSpan;
                currentCell += char;
            } else if (char === '\\' && i + 1 < row.length) {
                // 处理转义字符
                currentCell += char + row[i + 1];
                i++; // 跳过下一个字符
            } else if (char === '|' && !inCodeSpan) {
                // 只有在非代码段内的 | 才被视为分隔符
                cells.push(currentCell.trim());
                currentCell = '';
            } else {
                currentCell += char;
            }
            i++;
        }
        
        // 添加最后一个单元格
        if (currentCell.trim() || cells.length === 0) {
            cells.push(currentCell.trim());
        }
        
        return cells;
    };

    // 解析对齐方式
    const separatorCells = splitTableRow(separatorRow);
    const alignments = separatorCells.map((sep) => {
        const trimmed = sep.trim();
        if (trimmed.startsWith(':') && trimmed.endsWith(':')) {
            return 'center';
        } else if (trimmed.endsWith(':')) {
            return 'right';
        } else {
            return 'left';
        }
    });

    // 解析表头
    const headers = splitTableRow(headerRow);

    // 解析表体
    const body = [];
    if (bodyRows.trim()) {
        const rows = bodyRows.split(/\r?\n/).filter(row => row.trim());
        for (const row of rows) {
            if (row.trim()) {
                const cols = splitTableRow(row);
                body.push(cols);
            }
        }
    }

    // 确保所有行的列数一致（补齐空列或截断多余列）
    const maxColumns = Math.max(headers.length, alignments.length, ...body.map(row => row.length));
    
    // 补齐表头
    while (headers.length < maxColumns) {
        headers.push('');
    }
    
    // 补齐对齐设置
    while (alignments.length < maxColumns) {
        alignments.push('left');
    }
    
    // 补齐表体行
    body.forEach(row => {
        while (row.length < maxColumns) {
            row.push('');
        }
        // 截断多余的列
        if (row.length > maxColumns) {
            row.splice(maxColumns);
        }
    });

    return {
        headers: headers.slice(0, maxColumns),
        alignments: alignments.slice(0, maxColumns),
        rows: body,
    };
};



// 根据不同句子分隔符切割句子
function splitSentences(paragraph) {
    // 句子分隔符包括"."、"!"、"?"、汉字中的句号符号（。）、"？"和"！"
    return paragraph.split(/\.|\!|\?|。|？|！/).filter(sentence => sentence.trim() !== '');
}

// 判断是否为特殊段落（headings和list）
function isSpecialParagraph(paragraph) {
    // 假设特殊段落以"#"开头或以"*"、"-"或数字开头，可根据实际情况修改判断逻辑
    return paragraph.length < 300 && paragraph.startsWith("#") || /^\s*([*-]|\d+\.)\s+/.test(paragraph);
}

// 缩减文档长度
export const trimMarkdown = (markdownDocument, maxLength) => {
    let willDropLength = countWords(markdownDocument) - maxLength;
    let droppedLength = 0;

    // console.log('length............', countWords(markdownDocument), willDropLength)

    let paragraphs = markdownDocument.split("\n\n").filter(p => !!p).map(p => {
        if (isSpecialParagraph(p)) {
            return p;
        }

        return splitSentences(p);
    }).filter(p => !!p && p.length > 0);

    let nonSpecialParagraphs = paragraphs.map((p, index) => {
        if (typeof p !== 'string') {
            return {
                index
            }
        }

        return null;
    }).filter(item => !!item).map(item => item.index);

    const droppedParagraphs = [];
    while (willDropLength > droppedLength && nonSpecialParagraphs.length > 0) {
        let choosenParagraphIndex = nonSpecialParagraphs[chooseRandomly(nonSpecialParagraphs.length)];
        let choosenParagraph = paragraphs[choosenParagraphIndex];

        if (choosenParagraph.length === 0) {
            nonSpecialParagraphs = nonSpecialParagraphs.filter(item => item != choosenParagraphIndex);
            droppedParagraphs.push(choosenParagraphIndex);
            continue;
        }

        let choosenSentenceIndex = chooseRandomly(choosenParagraph.length);
        let choosenSentence = choosenParagraph[choosenSentenceIndex];

        droppedLength += countWords(choosenSentence);
        choosenParagraph.splice(choosenSentenceIndex, 1);
    }

    while (willDropLength > droppedLength && paragraphs.length > 1) {
        // console.log('drop paragraph, length............', willDropLength, droppedLength)
        let choosenParagraphIndex = chooseRandomly(paragraphs.length);
        while (droppedParagraphs.includes(choosenParagraphIndex)) {
            choosenParagraphIndex = chooseRandomly(paragraphs.length);
        }
        droppedLength += countWords(paragraphs[choosenParagraphIndex]);

        droppedParagraphs.push(choosenParagraphIndex);
    }

    return paragraphs.filter((p, index) => {
        return !droppedParagraphs.includes(index)
    }).map(p => {
        if (typeof p === 'string') {
            return p;
        } else {
            return p.join("。")
        }
    }).join("\n\n");
}

export const extractImageSrcs = (markdownText) => {
  const srcs = [];
  
  // 匹配 Markdown 图片语法：![alt](src)
  const markdownRegex = /!\[.*?\]\((.*?)\)/g;
  let match;
  while ((match = markdownRegex.exec(markdownText)) !== null) {
    if (match[1]) {
      srcs.push(match[1]);
    }
  }
  
  // 匹配 HTML 图片标签：<img src="...">
  const htmlRegex = /<img\s+[^>]*src\s*=\s*["']([^"']*)["'][^>]*>/gi;
  while ((match = htmlRegex.exec(markdownText)) !== null) {
    if (match[1]) {
      srcs.push(match[1]);
    }
  }
  
  return srcs;
}

function chooseRandomly(length) {
    const random = Math.floor(Math.random() * length);
    return random;
}

function countWords(text) {
    const wordPattern = /\b\w+\b/g;

    const englishWordCount = (text.match(wordPattern) || []).length;
    const chineseCharCount = text.replace(/[^\u4e00-\u9fa5]/g, "").length;
    //Todo: 不清楚ChatGPT是否算空格、标点符合之类的
    const otherCharCount = text.replace(/[\u4e00-\u9fa5]/g, "").replace(wordPattern, "").length;
    const totalWordCount = englishWordCount + otherCharCount + chineseCharCount;

    return totalWordCount;
}

